module.exports = __webpack_public_path__ + "static/media/ic_contact_form.b05454d0.svg";